/**
 * Lädt Master- (Produkt-Scope) + alle Channel-Package-Content-Blocks (C2).
 *
 * Master für die Vererbung/Vergleich, je Channel-Package die Override-Blocks
 * für die Chip-Abweichungs-Counts. Ein Query pro Scope (react-query cached).
 */

import { useQueries } from '@tanstack/react-query'
import { getContentBlocksForScope } from '@/lib/api/content-blocks'
import type { ContentBlock } from '@/types/content-blocks'
import type { ChannelPackage } from '@/types/channel-packages'

export function useChannelContentBlocks(productId: string, packages: ChannelPackage[]) {
  const results = useQueries({
    queries: [
      {
        queryKey: ['content-blocks', 'product', productId],
        queryFn: () => getContentBlocksForScope('product', productId),
        enabled: !!productId,
        staleTime: 30_000,
      },
      ...packages.map((p) => ({
        queryKey: ['content-blocks', 'channel_package', p.id],
        queryFn: () => getContentBlocksForScope('channel_package', p.id),
        enabled: !!productId,
        staleTime: 30_000,
      })),
    ],
  })

  const masterBlocks: ContentBlock[] = results[0]?.data?.content_blocks ?? []
  const channelBlocksByPkg: Record<string, ContentBlock[]> = {}
  packages.forEach((p, i) => {
    channelBlocksByPkg[p.id] = results[i + 1]?.data?.content_blocks ?? []
  })

  return {
    masterBlocks,
    channelBlocksByPkg,
    isLoading: results.some((r) => r.isLoading),
    isError: results.some((r) => r.isError),
  }
}
